module.exports = __webpack_public_path__ + "img/agent.029a0d86.png";